<template>
  <div class="flex flex-col items-start">
    <p
      ref="textBox"
      class="w-full text-body overflow-hidden"
      :class="[textBoxClasses]"
      :style="`word-break: break-word; -webkit-box-orient: vertical; display: ${
        expanded ? 'inline-block;' : '-webkit-box;'
      } -webkit-line-clamp: ${expanded ? 'none' : lineClamp};`"
    >
      <slot />
    </p>
    <button v-if="hasHiddenText" class="text-grey-clickable underline text-s mt-8" variant="text" @click="viewMoreHandler">
      {{ buttonText }}
    </button>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ViewMoreTextBox',
  components: {},
  props: {
    lineClamp: {
      default: 5,
      type: Number,
    },
    textBoxClasses: {
      default: '',
      type: String,
    },
    viewMoreButtonText: {
      default: 'View More',
      type: String,
    },
    viewLessButtonText: {
      default: 'View Less',
      type: String,
    },
  },
  data() {
    return {
      textElementInnerText: '',
      expanded: false,
      hasHiddenText: false,
    };
  },
  computed: {
    textElement(): HTMLElement {
      return this.$refs.textBox as HTMLElement;
    },
    buttonText(): string {
      if (this.expanded) return this.viewLessButtonText;
      return this.viewMoreButtonText;
    },
  },
  watch: {
    lineClamp(): void {
      this.checkHasHiddenText();
    },
    textElementInnerText(): void {
      this.checkHasHiddenText();
    },
  },
  mounted() {
    this.checkHasHiddenText();
    window.addEventListener('load', () => {
      // safeguard duplicate check just incase there is a layout shift during intial paint
      this.checkHasHiddenText();
    });
  },
  updated() {
    // this is a workaround used to make any text changes to the slot reactive
    this.textElementInnerText = this.textElement.innerText;
  },
  methods: {
    viewMoreHandler(): void {
      this.expanded = !this.expanded;
    },
    checkHasHiddenText(): void {
      this.$nextTick(() => {
        // needs nextTick to calculate paragraph height after any prop changes
        this.hasHiddenText = this.textElement.offsetHeight < this.textElement.scrollHeight;
      });
    },
  },
};
</script>
